const HEX_COLOUR_PATTERN = /^#[0-9a-f]{6}$/i;

export function isHexColour(value: unknown): value is string {
  return typeof value === 'string' && HEX_COLOUR_PATTERN.test(value);
}

export function normaliseHexColour(value: string): string | null {
  return isHexColour(value) ? value.toLowerCase() : null;
}

function colourChannels(colour: string): readonly [number, number, number] {
  return [
    Number.parseInt(colour.slice(1, 3), 16),
    Number.parseInt(colour.slice(3, 5), 16),
    Number.parseInt(colour.slice(5, 7), 16),
  ];
}

function channelHex(value: number): string {
  return Math.round(value).toString(16).padStart(2, '0');
}

export function interpolateHexColours(start: string, end: string, ratio: number): string {
  const boundedRatio = Math.min(1, Math.max(0, ratio));
  const startChannels = colourChannels(start);
  const endChannels = colourChannels(end);
  const channels = startChannels.map(
    (channel, index) => channel + ((endChannels[index] ?? channel) - channel) * boundedRatio,
  );
  return `#${channels.map(channelHex).join('')}`;
}

export function mixHexColour(colour: string, target: '#000000' | '#ffffff', ratio: number): string {
  return interpolateHexColours(colour, target, ratio);
}
